export enum DocumentProcessToStatus {
    Pending,
    Signed,
    Declined,
    Received
}

export const DocumentProcessToStatusTranslate = new Map<number, string>([
    [DocumentProcessToStatus.Pending, "documentProcessToStatus.Pending"],
    [DocumentProcessToStatus.Signed, "documentProcessToStatus.Signed"],
    [DocumentProcessToStatus.Declined, "documentProcessToStatus.Declined"],
    [DocumentProcessToStatus.Received, "documentProcessToStatus.Received"],
]);
